import { Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { ExpertChildTab, ExpertTabList } from './expert.const';
import { UserService } from '../../../../../common/services/User.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { UtilityService } from '../../../../../common/services/Utility.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NavigationEnd, Router } from '@angular/router';
import { getCurrentTab } from './expert.const';

@Component({
  selector: 'settings-expert',
  templateUrl: './expert.component.html',
  styleUrls: ['./expert.component.css'],
  providers: [UserService, GroupService, BsModalService, OrganizeService, UtilityService],
})
@Injectable()
export class ExpertComponent implements OnInit {
  public currentTab;
  public readonly expertTabList = ExpertTabList;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
  }

  onChangeTab(tabId: ExpertChildTab) {
    this.currentTab = tabId;
    this.router.navigate([tabId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/expert.component.ts